import { render, staticRenderFns } from "./SingleOrder.vue?vue&type=template&id=f9d387a0&scoped=true&"
import script from "./SingleOrder.vue?vue&type=script&lang=ts&"
export * from "./SingleOrder.vue?vue&type=script&lang=ts&"
import style0 from "./SingleOrder.vue?vue&type=style&index=0&id=f9d387a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9d387a0",
  null
  
)

export default component.exports